export enum SystemStatsCategory {
  ProcessData = 'ProcessData',
  CleaningConsumption = 'CleaningConsumption',
  Quality = 'Quality',
  Regeneration = 'Regeneration',
}
